import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact-card',
    templateUrl: './contact-card.component.html',
    styleUrls: ['./contact-card.component.scss'],
    standalone: false
})
export class ContactCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
